export const mergeArray = (stateArray, newArray) => {
    newArray.forEach(c => {
        const index = stateArray.findIndex(x => x.Id === c.Id);
        if (index === -1)
            stateArray.push(c);
        else
            stateArray[index] = c;
    });
};